import { call, put, takeLatest } from "redux-saga/effects";
import {
  createDepartmentStart,
  createDepartmentSuccess,
  createDepartmentFailure,
} from "../reducer";
import { networkErrorHandler } from "../../../utils/errorHandlers";
import { httpCreateDepartment } from "../../../services/department";
import { successNotifier } from "../../../utils/helpers";

export function* createDepartment({ payload }) {
  const { data, callback } = payload;
  const response = yield call(httpCreateDepartment, data);
  const { success, raw, message } = response;

  if (success) {
    yield put(createDepartmentSuccess());
    successNotifier("Department created successfully");
    if (callback) {
      callback();
    }
  } else {
    yield put(createDepartmentFailure(message || raw?.error));
    networkErrorHandler(response?.statusCode, message || raw?.error);
  }
}

export default function* onCreateDepartment() {
  yield takeLatest(createDepartmentStart.type, createDepartment);
}
